export default "__VITE_ASSET__B4Pm3IIz__"